//import { push } from 'react-router-redux';

//import { AuthConfig } from './../../conf/config';
//import {messagesDictionary} from './../../conf/messagesDictionary';
import { stringify as qsStringify } from 'querystring';

import * as types from './resetPasswordActionTypes';

import SingletonLibrary from '../../library/SingletonLibrary';

const sendMailSuccess = () => {
    return {
        type: types.SEND_MAIL_SUCCESS
    }
}

const changePasswordSuccess = () => {
    return {
        type: types.PASSWORD_CHANGED
    }
}

export const error = (errorMessage) => {
    return {
        type: types.ERROR,
        errorMessage
    }
}
export const errorLink = (errorMessage) => {
    return {
        type: types.ERROR_LINK,
        errorMessage
    }
}

export const errorSubscribe = (errorMessage) => {
    return {
        type: types.ERROR_SUBSCRIBE,
        errorMessage
    }
}

export const closeModal = () => {
    return {
        type: types.CLOSE_MODAL
    }
}

export const reset = () => {
    return {
        type: types.RESET
    }
}

export const sendResetPasswordMail = (username) => {
    return (dispatch) => {

        const formData = {
            'username' : username
        };

        SingletonLibrary
            .getAxiosInstance
            .post('/send-reset-password-mail', qsStringify(formData),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            } )
            .then((result) => {
                dispatch(sendMailSuccess());
            })
            .catch((e) => {

                if(typeof e.response === 'undefined' || typeof e.response.data === 'undefined')
                {
                    dispatch(error("une erreur s'est produite, réessaie plus tard"));    
                }
                else if(e.response.data.status === 400){
                    dispatch(errorSubscribe("Tu es sûr que tu fais partie du club Kids-Matin ? Rejoins-nous vite")); 
                }
                else{
                    dispatch(error("une erreur s'est produite, réessaie plus tard"));
                }
                    
            });
    };
}

export const updatePassword = (id, tim, control, password, passwordConfirm) => {
    return (dispatch) => {

        const formData = {
            'id' : id,
            'tim' : tim,
            'ct' : control,
            'password' : password,
            'password_confirm' : passwordConfirm
        };

        SingletonLibrary
            .getAxiosInstance
            .post('/reset-password', qsStringify(formData),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            } )
            .then((result) => {
                dispatch(changePasswordSuccess());
            })
            .catch((e) => {
                if(typeof e.response === 'undefined' || typeof e.response.data === 'undefined')
                {
                    dispatch(error("une erreur s'est produite, réessaie plus tard"));    
                }
                else if(e.response.data.status === 401){
                    dispatch(errorLink("Le lien sur lequel tu as cliqué n’est pas valide."));
                }
                else if (e.response.data.status === 400 && e.response.data.message === 'expired request' ){
                    dispatch(errorLink("Oups, c’est trop tard ! "));
                }
                else if (e.response.data.status === 400 && e.response.data.message === 'password differents' ){
                    dispatch(error("Tes mots de passe ne sont pas identiques :/")); 
                }
                else{
                    dispatch(error("une erreur s'est produite, réessaie plus tard"));
                }
            });
    };
}


export const sendForgottenUsernameMail = (email) => {
    return (dispatch) => {

        const formData = {
            email
        };

        SingletonLibrary
            .getAxiosInstance
            .post('/account/get-usernames', qsStringify(formData),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            } )
            .then((result) => {
                dispatch(sendMailSuccess());
            })
            .catch((e) => {

                if(typeof e.response === 'undefined' || typeof e.response.data === 'undefined')
                {
                    dispatch(error("une erreur s'est produite, réessaie plus tard"));    
                }
                else if(e.response.data.status === 400){
                    dispatch(error("N'oublie pas de renseigner le mail de tes parents")); 
                }
                else if(e.response.data.status === 401){
                    dispatch(error("Es-tu sûr d'avoir écrit le bon mail?")); 
                }
                else{
                    dispatch(error("une erreur s'est produite, réessaie plus tard"));
                }
                    
            });
    };
}


// WEBPACK FOOTER //
// ./src/components/ResetPassword/resetPasswordActions.js